<template>
<div v-if="show" class="permissions">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    requireAll: {
      type: Array
    },

    requireOne: {
      type: Array
    }
  },
  methods: {
    checkAll() {
      let valid = true

      this.requireAll.some((e) => {
        if (this.roles && this.roles.includes(e) === false) {
          return valid = false
        }
      })

      return valid
    },

    checkOne() {
      let valid = false

      this.requireOne.some((e) => {
        if (this.roles && this.roles.includes(e)) {
          return valid = true
        }
      })

      return valid
    }
  },

  computed: {
    roles() {
      return this.$store.getters.authUserRoles
    },

    // Show component
    show() {
      return this.requireAll ? this.checkAll() : this.checkOne()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/Permissions.vue